// eslint-disable-next-line no-use-before-define
import React, { useState } from 'react';
import { HeaderContainer } from './style';
import { Logo } from './components/logo';
import { Icon } from './components/icon';
import { Avatar } from './components/avatar';
import { ProfileMenu } from './components/profile-menu';
import { DownloadDrawerButton } from '../../../download-center/download-drawer-button';
export const HeaderComponent = ({ logout, openLangMenu, toggleSideMenu, openDownloadMenu, user, menu, isOpenSideMenu, }) => {
    const [isOpen, setIsOpen] = useState(false);
    const openProfileMenu = () => {
        setIsOpen(!isOpen);
    };
    return (React.createElement(HeaderContainer, null,
        React.createElement("div", { className: `main-menu` },
            React.createElement("div", { className: "main-menu_left-components" },
                !!menu?.length && (React.createElement(Icon, { onClick: toggleSideMenu, isOpen: isOpenSideMenu })),
                React.createElement(Logo, null)),
            React.createElement("div", { className: "main-menu_actions" },
                React.createElement(DownloadDrawerButton, { onClick: openDownloadMenu }),
                React.createElement(Avatar, { user: user, onClick: openProfileMenu }),
                React.createElement(ProfileMenu, { user: user, open: isOpen, logout: logout, openLangMenu: openLangMenu, onClose: () => setIsOpen(false) })))));
};
//# sourceMappingURL=component.js.map